import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dimensionCategoriesSelector } from "./dimensionCategoriesSelector";

export const dimensionCategoriesIdsSelector = createDraftSafeSelector(
  [dimensionCategoriesSelector],
  (categories) => Object.keys(categories),
);
